import React, {Component} from 'react';
import {Button, Modal} from 'semantic-ui-react';

import connect from "react-redux/es/connect/connect";
import {ticketHistoryDialog} from "../../actions/TicketHistroyActions";
import DynamicTable from "../extras/DynamicTable";

class TicketProduct extends Component{
    render(){
        return <strong>{this.props.ticket_product.product.name}</strong>
    }
}

class TicketHistory extends Component {
    constructor(){
        super();
        this.state={
            table:{}
        }
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.ticket_history_dialog && nextProps.ticket_history_dialog.ticket.id){
            this.setState({
                table: {
                    headers: ['Fecha', 'Producto'],
                    name: 'Historial',
                    title: 'Historial',
                    has_actions: false,
                    pagination: true,
                    url: `ticket-client/history/${nextProps.ticket_history_dialog.ticket.id}`,
                    values: ['id', 'date', 'ticket_product'],
                    datetime_fields: ['date'],
                    component_fields: [{ticket_product: TicketProduct}],
                    id: 'table_ticket_history'
            },})
        }
    }

    handleClose = () => {
        this.props.ticketHistoryDialog({open: false, ticket:{id:null, code:null}});
    };

    render() {
        return (
            <div>
                <Modal size='small' dimmer='inverted' open={this.props.ticket_history_dialog.open} onClose={this.handleClose}>
                    <Modal.Header>Tiquetera Nº {this.props.ticket_history_dialog.ticket.code} - Historial</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {this.props.ticket_history_dialog.ticket.id ?<DynamicTable {...this.state.table} />:null}
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ticket_history_dialog: state.get('ticket_history_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        ticketHistoryDialog(data) {
            dispatch(ticketHistoryDialog(data));
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TicketHistory);


// WEBPACK FOOTER //
// ./src/components/services/TicketHistory.js